const state = {
  customerInfo: {},
  // selected transactions
  transactions: [],
  tabList: [],
  selectedTab: {},
  allTranPages: [],
  rowSelected: false,
  key: 0,
  transactionListIndex: 0,
  postTransactionCustomerListIndex: 0
}

const mutations = {
  ADD_CUSTOMER_INFO: (state, data) => {
    state.customerInfo = data
  },
  ADD_TRANSACTIONS: (state, data) => {
    state.transactions = data
  },
  ADD_ALL_TRAN_PAGES: (state, data) => {
    state.allTranPages = data
  },
  ADD_TAB_LIST: (state, data) => {
    state.tabList = data
  },
  ADD_SELECTED_TAB: (state, data) => {
    state.selectedTab = data
  },
  CHANGE_ROW_SELECTED: (state, data) => {
    state.rowSelected = data
  },
  CHANGE_KEY: state => {
    state.key += 1
  },
  CHANGE_TRANSACTION_LIST_INDEX: state => {
    state.transactionListIndex += 1
  },
  CHANGE_POST_TRANSACTION_LIST_INDEX: state => {
    state.postTransactionCustomerListIndex += 1
  },
  RESTORE_ALL_STAGES: state => {
    // alert(1)
    state.customerInfo = {}
    state.transactions = []
    state.tabList = []
    state.selectedTab = {}
    state.rowSelected = false
    state.key = 0
    state.transactionListIndex = 0
    state.postTransactionCustomerListIndex = 0
  }
}

const actions = {
  addCustomerInfo({ commit }, data) {
    commit('ADD_CUSTOMER_INFO', data)
  },
  addTabList({ commit }, data) {
    commit('ADD_TAB_LIST', data)
  },
  addSelectedTab({ commit }, data) {
    commit('ADD_SELECTED_TAB', data)
  },
  addTransactions({ commit }, data) {
    commit('ADD_TRANSACTIONS', data)
  },
  addAllTranPages({ commit }, data) {
    commit('ADD_ALL_TRAN_PAGES', data)
  },
  changeRowSelected({ commit }, data) {
    commit('CHANGE_ROW_SELECTED', data)
  },
  changeKey({ commit }) {
    commit('CHANGE_KEY')
  },
  changeTransactionListIndex({ commit }) {
    commit('CHANGE_TRANSACTION_LIST_INDEX')
  },
  changePostTransactionListIndex({ commit }) {
    commit('CHANGE_POST_TRANSACTION_LIST_INDEX')
  },
  restoreAllStates({ commit }) {
    commit('RESTORE_ALL_STAGES')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
